import { axios } from '@ben/api/axios';
import type { AxiosRequestConfig } from 'axios';
import type { BenefitHeroImage } from '@ben/api/gen/codegen.schemas';

export const uploadBenefitHeroImage = async (
  data: unknown,
  options?: AxiosRequestConfig<unknown>
): Promise<BenefitHeroImage> => {
  const response = await axios.post<BenefitHeroImage>(
    `benefit-hero-image/`,
    data,
    options
  );
  return response.data;
};
